var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeebackMessageSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5416 105.234C27.2467 106.679 23.8679 103.379 25.2351 100.051L46.8434 47.451L82.6187 82.3948L30.5416 105.234Z",
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 1.54
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.6107,
    cy: 64.02,
    rx: 25.3624,
    ry: 7.49345,
    transform: "rotate(44.3263 65.6107 64.02)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5078 64.6211C63.9738 67.4878 69.5 74 78 78",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8203 67.7695L63.2548 90.7022",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8984 83.25L47.5984 97.985",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5317 30.9003L83.7216 31.6064C84.0321 32.7613 82.9745 33.8185 81.8197 33.5076V33.5076C80.5782 33.1734 79.4921 34.4075 79.9814 35.5965L80.2175 36.1703C80.7213 37.3944 79.82 38.7376 78.4964 38.7356L77.9136 38.7347C76.5783 38.7327 75.5356 39.8884 75.6746 41.2165L75.7791 42.215",
    stroke: "black",
    strokeWidth: 1.54,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2434 38.8573L60.4962 38.0031C60.9902 36.3342 59.9965 34.5893 58.3091 34.1627V34.1627C55.5721 33.4707 55.1477 29.7595 57.6578 28.4675L58.1695 28.2042C60.0804 27.2206 60.4126 24.6271 58.8111 23.1938V23.1938C56.4804 21.1077 52.9181 23.532 53.8776 26.5092V26.5092",
    stroke: "black",
    strokeWidth: 1.54,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6038 48.7226L96.0105 48.5659C94.8511 48.2597 93.6699 48.9795 93.4104 50.1502V50.1502C92.9897 52.049 90.4427 52.4168 89.5019 50.7146L89.3101 50.3676C88.5939 49.0717 86.8012 48.8959 85.8468 50.0278V50.0278C84.4577 51.6753 86.1997 54.079 88.2303 53.3576V53.3576",
    stroke: "black",
    strokeWidth: 1.54,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.57 79.043C106.592 72.7027 100.179 64.8749 97.6922 68.6652C95.9675 71.2943 101.895 76.4277 106.402 65.949",
    stroke: "black",
    strokeWidth: 1.54,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeebackMessageSuccess);
export default __webpack_public_path__ + "static/media/Feeback-Message-success.a9be6399b3cbc0cf63d6914c10c2a7db.svg";
export { ForwardRef as ReactComponent };